module.exports = __webpack_public_path__ + "static/media/Logo_MA_White.7b71b380.svg";